import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App";
import * as serviceWorkerRegistration from "./ServiceWorkerReg.js";
import { Logger } from "./services/logging-service";
import ErrorBoundary from "./shared/ErrorBoundary";


// Run cleanup on app start.
// We also initialize logging this way, by importing the Logger.
Logger.cleanOldLogs();

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root"),
);
serviceWorkerRegistration.register();
